/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import TableOfMarketManagement from './TableOfMarketManagement';
import SelectionOfMarketManagement from './SelectionOfMarketManagement';
import Typography from '@material-ui/core/Typography';

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};
class MarketManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    document.title = "市场管理";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          市场管理
        </Typography>
        <SelectionOfMarketManagement />
        <TableOfMarketManagement />
      </div>
    );
  }
}

const MarketManagement = observer(MarketManagementInner);

MarketManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MarketManagement);
